/* mox-draft-pdp.js — Interceptor de “Add to Cart” (solo usuarios logueados, draft-only) */
(function () {
  // Evita doble binding si el tema reinyecta secciones o scripts
  if (window.__moxPdpBound) return;
  window.__moxPdpBound = true;

  const ATC_SELECTOR = [
    '[data-add-to-cart]',
    'button[name="add"]',
    '.add-to-cart',
    '.product-form__submit',
    '.hdt-pr-atc',
    '.hdt-main-product-form [type="submit"]',
  ].join(',');

  // === Utilidades ===========================
  const toInt = (v, d = 0) => {
    const n = Number(String(v ?? '').replace(/[^\d]/g, ''));
    return Number.isFinite(n) ? n : d;
  };

  // === Listener oficial de la tabla mox- ===
  // Recibe { variantId, quantity, productId, size } desde mox-talla-table
  window.addEventListener('mox:draft:line:update:request', async (e) => {
    const { variantId, quantity } = e.detail || {};
    if (!variantId || Number.isNaN(Number(quantity))) return;

    if (!window.MOX_CUSTOMER_ID) {
      window.dispatchEvent(new CustomEvent('mox:auth:required'));
      window.openAuthModal?.('login');
      return;
    }

    try {
      if (quantity > 0) {
        if (window.MOX_DRAFT?.setQuantity) await window.MOX_DRAFT.setQuantity(variantId, quantity);
        else if (window.MOX_DRAFT?.addItem) await window.MOX_DRAFT.addItem(variantId, quantity);
      } else {
        if (window.MOX_DRAFT?.removeItem) await window.MOX_DRAFT.removeItem(variantId);
        else if (window.MOX_DRAFT?.setQuantity) await window.MOX_DRAFT.setQuantity(variantId, 0);
      }

      await window.MOX_DRAFT?.refreshLatestForCustomer?.();
      window.dispatchEvent(new CustomEvent('mox:draft:updated'));

      // Sincroniza tabla (estricto si existe; si no, fallback)
      if (window.MOX_STRICT_SYNC?.sync) {
        if (window.queueMicrotask) queueMicrotask(() => window.MOX_STRICT_SYNC.sync());
        else requestAnimationFrame(() => window.MOX_STRICT_SYNC.sync());
      } else if (window.MOX_SYNC?.syncPdpTablesFromDraft) {
        if (window.queueMicrotask) queueMicrotask(() => window.MOX_SYNC.syncPdpTablesFromDraft());
        else requestAnimationFrame(() => window.MOX_SYNC.syncPdpTablesFromDraft());
      }
    } catch (err) {
      console.error('[MOX] draft upsert error', err);
      window.dispatchEvent(new CustomEvent('mox:draft:refresh'));
    }
  });

  function readVariantAndQty(fromEl) {
    const form =
      (fromEl.closest && fromEl.closest('form')) ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form');

    const variantInput = form?.querySelector('input[name="id"], input[name="variant"], [data-variant-id]');
    const rawVariant = variantInput?.value || variantInput?.getAttribute?.('data-variant-id') || '';
    const m = String(rawVariant).match(/(\d+)$/);
    const variantIdNum = m ? m[1] : null;

    const qtyInput = form?.querySelector('input[name="quantity"], [data-qty]');
    const qty = toInt(qtyInput?.value ?? 1, 1);

    return { variantIdNum, qty: Math.max(1, qty) };
  }

  // Anti-doble disparo
  let lastHandledAt = 0;
  const HANDLE_COOLDOWN_MS = 700;
  function canHandleNow() {
    const now = Date.now();
    if (now - lastHandledAt < HANDLE_COOLDOWN_MS) return false;
    lastHandledAt = now;
    return true;
  }

  // Espera a que exista MOX_DRAFT.current o a que dispare mox:draft:loaded (con timeout)
  function waitForDraftLoaded(ms = 1500) {
    return new Promise((resolve) => {
      if (window.MOX_DRAFT?.current?.id) return resolve(window.MOX_DRAFT.current);

      let done = false;
      function finish() {
        if (done) return;
        done = true;
        window.removeEventListener('mox:draft:loaded', onLoaded);
        document.removeEventListener('mox:draft:loaded', onLoaded);
        resolve(window.MOX_DRAFT?.current || null);
      }
      function onLoaded() { finish(); }

      // (Listeners comentados a propósito en tu base estable)
      // window.addEventListener('mox:draft:loaded', onLoaded, { once: true });
      // document.addEventListener('mox:draft:loaded', onLoaded, { once: true });

      setTimeout(finish, ms);
    });
  }

  async function handleAdd(sourceEl) {
    if (!window.MOX_CUSTOMER_ID) {
      window.dispatchEvent(new CustomEvent('mox:auth:required'));
      window.openAuthModal?.('login');
      return;
    }

    const { variantIdNum, qty } = readVariantAndQty(sourceEl);
    if (!variantIdNum) {
      console.warn('[MOX] No pude obtener el variantId.');
      return;
    }

    let fired = false;
    function onLoadedOnce() {
      if (fired) return;
      fired = true;
      window.removeEventListener('mox:draft:loaded', onLoadedOnce);
      document.removeEventListener('mox:draft:loaded', onLoadedOnce);
      document.dispatchEvent(new CustomEvent('mox:shadow:open', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('mox:shadow:open'));
    }

    const draft = await window.MOX_DRAFT.addItem(variantIdNum, qty);

    const edges = draft?.lineItems?.edges;
    if (Array.isArray(edges) && edges.length && !fired) {
      onLoadedOnce();
      window.MOX_DRAFT.refreshLatestForCustomer?.().catch(() => { });
      return;
    }

    const readyDraft = await waitForDraftLoaded(1500);
    if (readyDraft?.id && !fired) {
      onLoadedOnce();
      window.MOX_DRAFT.refreshLatestForCustomer?.().catch(() => { });
      return;
    }

    if (window.MOX_DRAFT?.current && !fired) {
      onLoadedOnce();
    } else if (!fired) {
      window.bootDraftRefresh?.();
      setTimeout(() => {
        if (!fired && window.MOX_DRAFT?.current) onLoadedOnce();
      }, 800);
    }
  }

  async function handleAddInput(_qty, _variantId) {
    if (!window.MOX_CUSTOMER_ID) {
      window.dispatchEvent(new CustomEvent('mox:auth:required'));
      window.openAuthModal?.('login');
      return;
    }
    const variantIdNum = _variantId;
    const qty = _qty;

    let fired = false;
    function onLoadedOnce() {
      if (fired) return;
      fired = true;
      window.removeEventListener('mox:draft:loaded', onLoadedOnce);
      document.removeEventListener('mox:draft:loaded', onLoadedOnce);
      document.dispatchEvent(new CustomEvent('mox:shadow:open', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('mox:shadow:open'));
    }

    const draft = await window.MOX_DRAFT.addItem(variantIdNum, qty);

    const edges = draft?.lineItems?.edges;
    if (Array.isArray(edges) && edges.length && !fired) {
      onLoadedOnce();
      window.MOX_DRAFT.refreshLatestForCustomer?.().catch(() => { });
      return;
    }

    const readyDraft = await waitForDraftLoaded(1500);
    if (readyDraft?.id && !fired) {
      onLoadedOnce();
      window.MOX_DRAFT.refreshLatestForCustomer?.().catch(() => { });
      return;
    }

    if (window.MOX_DRAFT?.current && !fired) {
      onLoadedOnce();
    } else if (!fired) {
      window.bootDraftRefresh?.();
      setTimeout(() => {
        if (!fired && window.MOX_DRAFT?.current) onLoadedOnce();
      }, 800);
    }
  }

  function attachInterceptors() {
    const isLikelyPdp =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector(ATC_SELECTOR);
    if (!isLikelyPdp) return;

    document.addEventListener(
      'click',
      async (ev) => {
        const btn = ev.target.closest?.(ATC_SELECTOR);
        if (!btn) return;
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        if (!canHandleNow()) return;
        await handleAdd(btn);
      },
      true
    );

    // Submit del form (temas que disparan programáticamente)
    document.addEventListener(
      'submit',
      async (ev) => {
        const form = ev.target;
        if (!form || !form.querySelector(ATC_SELECTOR)) return;
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
        if (!canHandleNow()) return;
        await handleAdd(form);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachInterceptors, { once: true });
  } else {
    attachInterceptors();
  }

  document.addEventListener('shopify:section:load', () => {
    attachInterceptors();
  });
})();

// /* ==========================================================
//    Mox · Poner el slide de la variante en 1ª posición + sombra sutil
//    - Al cambiar el radio "Color", mueve el slide de esa variante
//      a la PRIMERA posición del carrusel y le aplica una sombra suave.
//    - Si ya está primero: sólo actualiza la sombra.
//    ========================================================== */
//
// (function () {
//   if (window.__moxPinByImageInit) return;
//   window.__moxPinByImageInit = true;
//
//   // === Utils ==========================================================
//   const q  = (s, r)=> (r||document).querySelector(s);
//   const qq = (s, r)=> Array.from((r||document).querySelectorAll(s));
//
//   function normalizeImgUrl(u) {
//     try {
//       // Acepta //host/path?width=... y quita query/hash
//       const url = new URL(u.replace(/^\/\//, location.protocol + '//'));
//       return url.origin + url.pathname;
//     } catch {
//       // Si no es URL absoluta, quita query/hash a mano
//       return String(u||'').split('?')[0].split('#')[0];
//     }
//   }
//
//   function getMainSliderCtx() {
//     const viewport  = q('.hdt-product-media__main .hdt-slider__viewport');
//     const container = q('.hdt-product-media__main .hdt-slider__container');
//     const api = viewport?.__hdtSlider || viewport?.slider || viewport?.swiper || viewport?.__swiper || null;
//     return { viewport, container, api };
//   }
//
//   function findSlideByImageSrc(thumbnailSrc) {
//     if (!thumbnailSrc) return null;
//     const target = normalizeImgUrl(thumbnailSrc);
//     const { container } = getMainSliderCtx();
//     if (!container) return null;
//
//     // Busca <img> dentro de cada slide y compara por URL normalizada
//     const slides = qq('.hdt-slider__slide', container);
//     for (const slide of slides) {
//       const img = q('img', slide);
//       if (!img) continue;
//       const slideSrc = normalizeImgUrl(img.currentSrc || img.src || '');
//       if (slideSrc === target) return slide;
//     }
//     return null;
//   }
//
//   function goToSlide(slide) {
//     if (!slide) return;
//     const { container, api } = getMainSliderCtx();
//     if (!container) return;
//
//     const slides = qq('.hdt-slider__slide', container);
//     const idx = slides.indexOf(slide);
//
//     // Si el carrusel expone API, úsala; si no, reordena DOM.
//     if (api && typeof api.slideTo === 'function') {
//       api.update?.();
//       if (idx >= 0) api.slideTo(idx);
//       else {
//         container.insertBefore(slide, container.firstElementChild);
//         api.update?.(); api.slideTo?.(0);
//       }
//     } else {
//       if (container.firstElementChild !== slide) {
//         container.insertBefore(slide, container.firstElementChild);
//       }
//     }
//
//     // Marca visual opcional
//     qq('.hdt-slider__slide.mox-slide--selected').forEach(s=>s.classList.remove('mox-slide--selected'));
//     slide.classList.add('mox-slide--selected');
//   }
//
//   function readThumbSrcFromRadio(radio) {
//     // Busca el <label for="..."> y toma el <img> de la miniatura
//     const label = radio.id ? q(`label[for="${radio.id}"]`) : radio.closest('label');
//     const img = label?.querySelector('img');
//     return img?.currentSrc || img?.src || null;
//   }
//
//   // === Handler principal: al cambiar Color ============================
//   function onColorChange(ev) {
//     const radio = ev.target;
//     if (!radio?.matches?.('input[type="radio"][name="Color"]')) return;
//
//     // Tomamos la imagen de la miniatura del color seleccionado
//     const thumbSrc = readThumbSrcFromRadio(radio);
//     if (!thumbSrc) return;
//
//     // Buscamos el slide con la misma imagen y lo llevamos al frente
//     // (pequeño delay por si el theme re-renderiza tras el cambio)
//     setTimeout(() => {
//       const slide = findSlideByImageSrc(thumbSrc);
//       if (slide) goToSlide(slide);
//     }, 30);
//   }
//
//   // === Enganches ======================================================
//   document.addEventListener('change', onColorChange, true);
//
//   // Boot inicial: aplica al radio ya seleccionado
//   const checked = q('input[type="radio"][name="Color"]:checked');
//   if (checked) {
//     setTimeout(() => {
//       const thumbSrc = readThumbSrcFromRadio(checked);
//       const slide = thumbSrc && findSlideByImageSrc(thumbSrc);
//       if (slide) goToSlide(slide);
//     }, 60);
//   }
//
//   // Si el slider se rehidrata, vuelve a aplicar
//   const { container } = getMainSliderCtx();
//   if (container) {
//     const mo = new MutationObserver(() => setTimeout(() => {
//       const chk = q('input[type="radio"][name="Color"]:checked');
//       if (!chk) return;
//       const thumbSrc = readThumbSrcFromRadio(chk);
//       const slide = thumbSrc && findSlideByImageSrc(thumbSrc);
//       if (slide) goToSlide(slide);
//     }, 60));
//     mo.observe(container, { childList: true, subtree: true });
//   }
//
//   console.log('[mox] Pin por imagen de miniatura listo.');
// })();
